"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  GraphicTabletDrawingPen: ['graphic-tablet-drawing-pen', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.194,16.562a.5.5,0,0,0-.816.164L.756,20.665a1.972,1.972,0,0,0-.085,1.25l-.378.378a1,1,0,0,0,1.414,1.414l.378-.378a1.973,1.973,0,0,0,1.25-.086l3.939-1.622a.5.5,0,0,0,.163-.815Z', 'M23.267,2.145,21.853.731a2.5,2.5,0,0,0-3.536,0l-1.06,1.061a.5.5,0,0,0,0,.707L21.5,6.741a.5.5,0,0,0,.707,0L23.267,5.68A2.5,2.5,0,0,0,23.267,2.145Z', 'M16.3,3.457a.516.516,0,0,0-.707,0L4.152,14.9a.5.5,0,0,0,0,.707L8.4,19.849a.5.5,0,0,0,.707,0L20.543,8.406a.5.5,0,0,0,0-.707Z']],
  GraphicTabletIntousDraw: ['graphic-tablet-intous-draw', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.953,18.075A.251.251,0,0,0,13.776,18H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H21a1,1,0,0,1,1,1V17a.992.992,0,0,1-.129.49.251.251,0,0,0,.041.3l1.221,1.22a.25.25,0,0,0,.378-.027A2.486,2.486,0,0,0,24,17.5V2.5A2.5,2.5,0,0,0,21.5,0H2.5A2.5,2.5,0,0,0,0,2.5v15A2.5,2.5,0,0,0,2.5,20H15.276a.25.25,0,0,0,.177-.427ZM5.25,3H2.75a.75.75,0,0,1,0-1.5h2.5a.75.75,0,0,1,0,1.5Zm6.75.75A1.25,1.25,0,1,1,13.25,2.5,1.25,1.25,0,0,1,12,3.752ZM21.25,3h-2.5a.75.75,0,0,1,0-1.5h2.5a.75.75,0,0,1,0,1.5Z', 'M13.669,11.668a.506.506,0,0,0-.2-.12l-1.94-.647a.5.5,0,0,0-.632.633l.646,1.939a.5.5,0,0,0,.121.195l9.917,9.917a1.414,1.414,0,0,0,2-2Z']],
  GraphicTabletPen: ['graphic-tablet-pen', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.538,16.366a.248.248,0,0,0-.176-.073H8a1,1,0,0,1-1-1v-11a1,1,0,0,1,1-1H21a1,1,0,0,1,1,1v11a.994.994,0,0,1-.269.681.249.249,0,0,0,.006.347l1.206,1.207a.251.251,0,0,0,.357,0,2.492,2.492,0,0,0,.7-1.732v-12a2.5,2.5,0,0,0-2.5-2.5H2.5A2.5,2.5,0,0,0,0,3.793v12a2.5,2.5,0,0,0,2.5,2.5H14.862a.25.25,0,0,0,.176-.427ZM4.25,10.545H2.75a.75.75,0,0,1,0-1.5h1.5a.75.75,0,0,1,0,1.5Zm.75,3a.75.75,0,0,1-.75.75H2.75a.75.75,0,0,1,0-1.5h1.5A.75.75,0,0,1,5,13.545ZM4.25,6.8H2.75a.75.75,0,0,1,0-1.5h1.5a.75.75,0,0,1,0,1.5Z', 'M13.669,10.375a.506.506,0,0,0-.2-.12l-1.94-.647a.5.5,0,0,0-.632.633l.646,1.939a.494.494,0,0,0,.121.2l9.917,9.917a1.414,1.414,0,0,0,2-2Z']],
  GraphicTabletDraw: ['graphic-tablet-draw', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.073,7.549A.249.249,0,0,0,22,7.726V19.5a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7.5a1,1,0,0,1,1-1H14.776a.251.251,0,0,0,.177-.073l1.5-1.5a.25.25,0,0,0-.177-.427H3a3,3,0,0,0-3,3v12a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V7.5a2.9,2.9,0,0,0-.242-1.152.251.251,0,0,0-.406-.078Z', 'M16.75,16a.25.25,0,0,0-.25.25V18.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V16.25a.25.25,0,0,0-.25-.25Z', 'M16.666,12.956a.634.634,0,0,1-.069.059.253.253,0,0,0-.1.2V14.75a.25.25,0,0,0,.25.25h3.5a.25.25,0,0,0,.25-.25V12.5A.5.5,0,0,0,20,12H17.725a.247.247,0,0,0-.176.073Z', 'M23.586,1.915a1.412,1.412,0,0,0-2,0L13.605,9.9l-.684,2.051a.5.5,0,0,0,.475.658.506.506,0,0,0,.158-.025l2.051-.684,7.981-7.981A1.415,1.415,0,0,0,23.586,1.915Z', 'M7.5,10.25a4.25,4.25,0,1,0,4.25,4.25A4.255,4.255,0,0,0,7.5,10.25Zm0,7a2.75,2.75,0,1,1,2.75-2.75A2.752,2.752,0,0,1,7.5,17.25Z', 'M6.000 14.500 A1.500 1.500 0 1 0 9.000 14.500 A1.500 1.500 0 1 0 6.000 14.500 Z']],
  GraphicTabletDraw1: ['graphic-tablet-draw-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,8a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V9A1,1,0,0,1,3,8h8.776a.251.251,0,0,0,.177-.073l1.5-1.5A.25.25,0,0,0,13.276,6H3A3,3,0,0,0,0,9V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V9a3,3,0,0,0-1.88-2.782.25.25,0,0,0-.271.055l-1.3,1.3A.25.25,0,0,0,20.726,8Z', 'M18.25,14A1.252,1.252,0,0,0,17,12.75h-.5a.75.75,0,0,0,0,1.5.25.25,0,0,1,.25.25v4a.25.25,0,0,1-.25.25h-8a.25.25,0,0,1-.25-.25V17.25H12A1.252,1.252,0,0,0,13.25,16V14.45a.25.25,0,0,0-.326-.238l-1,.321a.25.25,0,0,0-.174.238V15.5a.25.25,0,0,1-.25.25h-6a.25.25,0,0,1-.25-.25v-4a.25.25,0,0,1,.25-.25H9.548a.251.251,0,0,0,.236-.169l.344-1a.25.25,0,0,0-.236-.331H5A1.252,1.252,0,0,0,3.75,11v5A1.252,1.252,0,0,0,5,17.25H6.75V19A1.252,1.252,0,0,0,8,20.25h9A1.252,1.252,0,0,0,18.25,19Z', 'M21.586.415l-9.917,9.917a.494.494,0,0,0-.121.195L10.9,12.466a.5.5,0,0,0,.632.633l1.94-.647a.506.506,0,0,0,.2-.12l9.917-9.917a1.414,1.414,0,0,0-2-2Z']]
};
exports["default"] = _default;